import * as React from "react";
import type { SVGProps } from "react";
const SvgArrowSwitchHorizontal1 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M14.4 6 18 2.4m0 0L21.6 6M18 2.4v19.2M9.6 18 6 21.6m0 0L2.4 18M6 21.6V2.4"
    />
  </svg>
);
export default SvgArrowSwitchHorizontal1;
